import signup from "./signup";
import login from "./login";
import logout from "./logout";
import refresh from "./refresh";
import getLoginStatus from "./getLoginStatus";
import getUser from "./getUser";
import updateMe from "./updateMe";
import succesion from "./succesion";
import find from "./find";
import checkEmail from "./checkEmail";
import sendCode from "./sendCode";
import checkCode from "./checkCode";

export default {
  signup,
  login,
  logout,
  refresh,
  getLoginStatus,
  getUser,
  updateMe,
  succesion,
  find,
  checkEmail,
  sendCode,
  checkCode,
};
